import React, { useState } from 'react'
import getBackgroundcolor from '../func/getBackgroundcolor';
import config from '../config.json'
import Translation from '../../Translation/cont/Translation';
import checkForAttributeMapping from '../../../functions/checkForAttributeMapping';

const ItemAttributes = ({attributes, accentColorDark, translation, chosen_font, accentColor, themeColors, iconsColor, hide2d=false}) => {
    let colorToUse = 1
    
    return attributes.map((attribute, index) => {
        const id = String(attribute.id)
        const {name} = attribute 
        let style
        
        if(id !== 'fsk' && id !== 'length') {
            if(hide2d && (id === '1087' || id === '2d' || id === 'digital')) {
                return ''
            }
            
            if(id === '1087' || id === '2d' || id === 'digital') {
                style = {
                    backgroundColor: getBackgroundcolor(accentColorDark, attribute, themeColors),
                    border: '1px #dfdfdf solid'
                }
            } else if(id === '1522' || id === '1088' || id === '1666' || id === '3d') {
                style = {
                    backgroundColor: getBackgroundcolor(accentColorDark, attribute, themeColors)
                }
            } else {
                if(colorToUse === 1) {
                    style = {
                        border: '1px solid ' +  accentColorDark
                    }
                    colorToUse++
                } else if(colorToUse === 2) {
                    style = {
                        border: '1px solid ' +  accentColor,
                        filter: "sepia(1)"
                    }
                    colorToUse++
                }  else if(colorToUse === 3) {
                    style = {
                        border: '1px solid ' +  accentColor,
                        filter: "sepia(1) invert(1) brightness(1.5)"
                    }
                    colorToUse++
                } else {
                    style = {
                        border: '1px solid ' +  accentColorDark,
                        filter: "invert(1)"
                    }
                }
            }
        } else {
            if(themeColors === 'Dark' || themeColors === 'Kmotion') {
                style = {
                    border: '1px solid #616161'
                }
            } else {
                style = {
                    border: '1px solid #dddddd'
                }
            }
        }
    
        const attributesName = (id !== 'fsk' && id !== 'length') ? checkForAttributeMapping(name, translation) : name
        const logoClass = _.contains(config.attributesWithIcons, id) ? 'attribute-logo ' + iconsColor + '-attribute': 'other-attribute'
        const doNotDisplayTitle = _.contains(config.attributesWithIcons, id) ? 'screen-reader-text ' : ''

        return (
            <div key={index} className={'attribute'}>
                <div style={style} className={'border-element ' + id}></div>
                <span data-attribute={id} className={logoClass}>
                    <span className={doNotDisplayTitle + `${chosen_font}-text-xsmall-light`}>
                        {id === 'fsk' && <Translation id="movie_attributes_fsk" after=' '/>}
                        {attributesName}
                        {id === 'length' &&  <Translation id="movie_attributes_length_unit"  before=' '/>}
                    </span>
                </span>
            </div>
        )
    })
}

export default ItemAttributes